import { z } from "zod";
import { POC_NAME, POC_DESIGNATION, POC_DEPARTMENT, POC_PHONE, POC_EMAIL } from "./consts";

// Form validation schema for School POC
export const schema = z.object({
  [POC_NAME]: z.string().min(1, "POC Name is required"),
  [POC_DESIGNATION]: z.string().min(1, "POC Designation is required"),
  [POC_PHONE]: z.string()
    .min(1, "POC Phone is required")
    .regex(/^[6-9]\d{9}$/, "Please enter a valid 10-digit mobile number"),
  [POC_EMAIL]: z.string(),
});

export type FormValues = z.infer<typeof schema>;
